module.exports = __webpack_public_path__ + "static/board-12-b1abf073a6322d56abbead684ac8a5e9.jpg";